/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  padding: 40px;
  display: grid;
  grid-template-columns: 360px 360px;
  grid-row-gap: 40px;
  grid-column-gap: 40px;

  @media (max-width: 1200px) {
    display: grid;
    grid-template-columns: 360px;
  }

  width: 100%;
`;

export const Header = styled.div`
  height: 100px;
  width: 90%;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  div.scorecard {
    height: 80px;
    width: 70%;
    margin-left: 5%;

    border: 1px solid #fff;
    background: #fff;
    border-radius: 10px;

    padding: 20px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  div.flag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  div.detail {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    margin: 0 20px;

    p {
      font-size: 20px;
    }
  }

  div.subDetail {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    margin: 0 20px;

    p {
      font-size: 16px;
    }
  }
`;

export const Body = styled.div`
  margin-left: 50px;
  margin-top: 20px;

  div.title {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
    }
    p {
      color: #fff;
      margin-left: 5px;
      font-weight: bold;
    }
  }
  div.wrong {
    width: 90%;
    padding: 20px;

    display: grid;
    grid-template-columns: 500px 500px;

    @media (max-width: 1200px) {
      display: grid;
      grid-template-columns: 500px;
    }

    div.content {
      background: #fff;
    }

    div.bar {
      background: #ff0000;
      width: 15px;
      height: 15px;
      border-radius: 7.5px;

      position: relative;
      top: -5px;
      left: 202px;
    }
  }

  div.pending {
    width: 90%;
    padding: 20px;

    display: grid;
    grid-template-columns: 500px 500px;

    @media (max-width: 1200px) {
      display: grid;
      grid-template-columns: 500px;
    }

    div.content {
      background: #fff;
    }

    div.bar {
      background: #ffe800;
      width: 15px;
      height: 15px;
      border-radius: 7.5px;

      position: relative;
      top: -5px;
      left: 202px;
    }
  }

  div.correct {
    width: 90%;
    padding: 20px;
    margin-bottom: 400px;

    display: grid;
    grid-template-columns: 500px 500px;

    @media (max-width: 1200px) {
      display: grid;
      grid-template-columns: 500px;
    }

    div.content {
      background: #fff;
    }

    div.bar {
      background: #00f016;
      width: 15px;
      height: 15px;
      border-radius: 7.5px;

      position: relative;
      top: -5px;
      left: 202px;
    }
  }
`;

export const Card = styled.button`
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 15px 10px;
  border: none;
  img {
    height: 120px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  div.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    /* background: #fff; */
    width: 30vw;
    max-width: 30vw;
    height: 120px;
    /* border: 1px solid #fff; */
    padding: 10px;

    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;

    div.icons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: space-between;

      width: 100%;

      div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;

export const Summary = styled.div`
  div.challenges {
    /* width: 70%; */
    /* height: 100px; */
    color: #fff;
    font-weight: bold;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-left: 30px;
    margin-bottom: 40px;

    div.support-scorecard {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      div.scorecard {
        height: 130px;
        width: 20vw;
        margin-left: 10px;

        background: #28316c;
        border-radius: 5px;

        padding: 20px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      div.flag {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      div.detail {
        height: 130px;
        width: 15vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        margin: 0 5px;

        background: #28316c;
        border-radius: 5px;

        div.image {
          position: relative;
          left: -70px;
          width: 35px;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          text-align: center;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          margin-bottom: 15px;
          img {
            width: 25px;
          }
        }

        p {
          font-size: 20px;
        }
        div.subDetail {
          text-align: center;

          margin: 0 20px;

          p {
            font-size: 16px;
          }

          div.n {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 150px;

            p.number {
              font-size: 50px;
              font-weight: bold;
            }
            div {
              p {
                font-size: 18px;
                color: #aaa;
              }
            }
          }
        }
      }
    }
  }
`;

// export const Modal = styled.div`
//   z-index: 2;
//   position: absolute;
//   /* top: 20%;
//   bottom: 20%;
//   left: 10%;
//   right: 10%; */

//   width: 100%;
//   height: 100%;

//   background: #fff;
//   border: 1px solid #fff;
// `;
